export default "__VITE_ASSET__COo48q4A__"